import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';

@Component({
    selector: 'app-dialog-copy-os',
    templateUrl: './dialog-copy-os.component.html',
    styleUrls: ['./dialog-copy-os.component.scss']
})
export class DialogCopyOsComponent implements OnInit {

    copyForm: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<DialogCopyOsComponent>,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.copyForm = this.createFormCopy();
    }

    createFormCopy() {
        return this.fb.group({
            date: new FormControl(moment().format("YYYY-MM-DD"), Validators.required),
            hour: new FormControl(moment().format("HH:mm:ss"), Validators.required),
        })
    }

    confirm() {
        if (this.copyForm.invalid) {
            this.copyForm.markAllAsTouched();
            return;
        }
        const data =  this.copyForm.getRawValue();
        data.date = moment(data.date).format("YYYY-MM-DD")
        this.dialogRef.close(data);
    }
    dimiss() {
        this.dialogRef.close();
    }
}
